// @ts-strict-ignore
import {
  Component,
  computed,
  inject,
  Signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';

import { MatRipple } from '@angular/material/core';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { QuickCreationNav } from './quick-creation.nav';
import { HeaderFacade } from '../header.facade';

@Component({
  selector: 'fc-quick-creation',
  imports: [IconComponent, MatRipple, ButtonComponent, MatDialogClose],
  template: `
    <div class="quick-creation-header align-center justify-between">
      <div class="h2">Quick creation</div>
      <fc-button variant="icon" [mat-dialog-close]="true" icon="icon-close" />
    </div>
    <div class="quick-creation">
      @for (item of quickCreationNav(); track item) {
        <div class="title text-sm">{{ item.name }}</div>
        <div class="group">
          @for (child of item.children; track child) {
            <div
              (click)="this.quickCreationClick(child)"
              matRipple
              class="item pointer"
            >
              @if (child.icon) {
                <fc-icon [icon]="child.icon" [size]="16" />
              }
              <div class="h4 name text-secondary">{{ child.name }}</div>
            </div>
          }
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    @use 'var' as *;

    :host {
      padding: 12px 16px;
      overflow: hidden;

      @media (max-width: $sm-size) {
        height: $full-mobile-height;
        width: 320px;
      }
    }

    :host,
    .quick-creation {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .quick-creation {
      overflow-y: auto;
    }

    .group {
      display: flex;
      flex-direction: column;
      border: 1px solid $secondary-100;
      border-radius: 6px;
    }

    .item {
      display: flex;
      padding: 12px 16px;
      gap: 8px;
      align-items: center;
      background-color: $secondary-50;
      border-bottom: 1px solid $secondary-100;

      &:first-of-type {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      &:last-of-type {
        border-bottom: none;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  `,
})
export class QuickCreationComponent {
  store = inject(Store);
  dialogRef = inject(MatDialogRef<QuickCreationComponent>);
  router = inject(Router);
  headerFacade = inject(HeaderFacade);

  quickCreationNav = this.headerFacade.quickCreationNavs;

  quickCreationClick(evt?: QuickCreationNav): void {
    this.headerFacade.navigateQuickCreation(evt);
    this.dialogRef.close();
  }

  quickCreation: Signal<QuickCreationNav> = computed(() => {
    return this.quickCreationNav()
      .map((nav) => nav.children)
      .flat()
      .find((nav) => nav.type === this.headerFacade.quickCreation()?.type);
  });
}
